export enum ScaleMode {
    FitPageWidth,
    FitPage,
    Specific
}
